import { platformClient } from "@homy/api-client";

/**
 * Platform Admin Security API Client Methods
 */

/**
 * Change operator password.
 * @param {Object} params
 * @param {string} params.currentPassword
 * @param {string} params.newPassword
 * @param {string} [params.confirmPassword]
 * @returns {Promise<{success: boolean, message: string}>}
 */
export async function changePassword({ currentPassword, newPassword, confirmPassword }) {
  const response = await platformClient.post("/security/password", {
    currentPassword,
    newPassword,
    confirmPassword,
  });
  return response.data;
}

/**
 * Retrieve operator MFA enrollment status.
 * @returns {Promise<{isMfaEnabled: boolean, mfaMethod: string|null, backupCodesCount: number, hasBackupCodes: boolean}>}
 */
export async function getMfaStatus() {
  const response = await platformClient.get("/security/mfa/status");
  return response.data;
}

/**
 * Initialize TOTP enrollment and generate secret + QR URI + backup recovery codes.
 * @returns {Promise<{secret: string, provisioningUri: string, backupCodes: string[]}>}
 */
export async function setupTotp() {
  const response = await platformClient.post("/security/mfa/totp/setup");
  return response.data;
}

/**
 * Confirm TOTP enrollment using a 6-digit verification code.
 * @param {string} code
 * @returns {Promise<{success: boolean, message: string}>}
 */
export async function confirmTotp(code) {
  const response = await platformClient.post("/security/mfa/totp/confirm", {
    code,
  });
  return response.data;
}

/**
 * Disable MFA with step-up operator password verification.
 * @param {string} password
 * @returns {Promise<{success: boolean, message: string}>}
 */
export async function disableMfa(password) {
  const response = await platformClient.post("/security/mfa/disable", {
    password,
  });
  return response.data;
}

export { platformClient };

export const securityApi = {
  changePassword,
  getMfaStatus,
  setupTotp,
  confirmTotp,
  disableMfa,
};

export default securityApi;
